import { api } from "utils/api";

/**
 * Customer suspend/activate via POST /db/customers/suspension.
 * The backend also suspends/activates linked contracts and all recurring invoices
 * for the customer in the same transaction.
 */

const toMySqlDateTime = (value) => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) {
    const now = new Date();
    return now.toISOString().slice(0, 19).replace("T", " ");
  }
  return date.toISOString().slice(0, 19).replace("T", " ");
};

const toggleCustomerSuspension = async ({ customerId, suspended, description, actionDateTime }) => {
  if (!customerId) {
    return { success: false, result: null };
  }

  const response = await api.post("/db/customers/suspension", {
    customer_id: customerId,
    suspended: suspended ? 1 : 0,
    description: description || "",
    datetime: toMySqlDateTime(actionDateTime),
  });

  return {
    success: Boolean(response?.success),
    result: response?.result || null,
  };
};

export const suspendCustomer = async ({ customerId, description, actionDateTime }) => {
  const response = await toggleCustomerSuspension({
    customerId,
    suspended: true,
    description: description || "",
    actionDateTime,
  });
  return Boolean(response?.success);
};

export const activateCustomer = async ({ customerId, description, actionDateTime }) => {
  const response = await toggleCustomerSuspension({
    customerId,
    suspended: false,
    description: description || "",
    actionDateTime,
  });
  return Boolean(response?.success);
};
